module.exports = __webpack_public_path__ + "img/keyboard_r2.7bf9b55e.png";